<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-fieldset>


    <ng-template pTemplate="header">USUARIOS DE SOPORTE</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <!--ng-template pTemplate="left">
            <button pButton pRipple label="Regresar" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template-->
    
        <!--<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>-->
    </p-toolbar>
    <div class="card">

        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <div class="card">
                    <div class="p-fluid">
                        <div class="p-field p-grid">
                            
                            <div class="p-mr-2 p-mb-2">
                                <button pButton pRipple type="button" icon="pi pi-plus" label="Agregar" class="p-button-raised p-button-success" (click)="createUser()"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p-table #dt [value]="usersSupportDocList" [rows]="20" [paginator]="true" [globalFilterFields]="['userId','userName','email','cellPhone','language']"
                [(selection)]="selectedUsersSupportDoc" [rowHover]="true" dataKey="storeId" styleClass="p-datatable-responsive-demo"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true" editMode="row" responsiveLayout="scroll">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <h5 class="p-m-0">Opciones {{findOptInput}}   </h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
                        </span>
                    </div>
                    
                    <span class="p-input-icon-left">
                        <button type="button" pButton pRipple icon="pi pi-plus" (click)="openNewOption()" class="p-mr-4" pTooltip="Agregar Opción" tooltipPosition="bottom" *ngIf="this.userCanEdit"></button>
                        <!--button type="button" pButton pRipple (click)="goBack()" class="p-mr-4" pTooltip="Regresar" tooltipPosition="bottom">Regresar</button-->
                        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                    </span>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="userId">User Id<p-sortIcon field="userId"></p-sortIcon></th>
                        <th pSortableColumn="userName">Nombre<p-sortIcon field="userName"></p-sortIcon></th>
                        <th pSortableColumn="email">Email<p-sortIcon field="email"></p-sortIcon></th>
                        <th pSortableColumn="cellPhone">Celular<p-sortIcon field="cellPhone"></p-sortIcon></th>
                        <th pSortableColumn="language">Idioma<p-sortIcon field="language"></p-sortIcon></th>
                        <th pSortableColumn="function">Función<p-sortIcon field="function"></p-sortIcon></th>
                        <th pSortableColumn="function">Tipo<p-sortIcon field="function"></p-sortIcon></th>
                        <th >Editar</th>
                        <th >Eliminar</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user>
                    <tr>
                        <td>{{user.userId}}</td>
                        <td>{{user.userName}}</td>
                        <td>{{user.email}}</td>
                        <td>{{user.cellPhone}}</td>
                        <td>{{user.language != null ? user.language : ""}}</td>
                        <td>{{user.function}}</td>
                        <td>{{user.type}}</td>
                        <td>
                            <button type="button"  pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" (click)="editUser(user)"></button>
                        </td>
                        <td>
                            <button type="button"  pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteUserSupport(user)"></button>
                        </td>
                        
                    </tr>
                </ng-template>

                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        En total hay {{lstOptionRules ? lstOptionRules.length : 0 }} usuarios.
                    </div>
                </ng-template>
        </p-table>

        
    </div>

    <p-dialog [(visible)]="optionDialog" [style]="{width: '550px'}" header="Detalle Usuario" [modal]="true" styleClass="p-fluid" (onShow)="onShowModalOption()" >
        <ng-template pTemplate="content">
            <div class="field p-text-bold">
                <label for="opt">Usuario</label>
                    <input type="text" pInputText id="name" [(ngModel)]="userView.userId" required autofocus />
                    <small class="p-error" *ngIf="submitted && !userView.userId">Se requiere usuario</small>
                </div>

            <div class="field p-text-bold">
                <label for="opt">Nombre</label>
                <input type="text" pInputText id="name" [(ngModel)]="userView.userName" required autofocus />
                <small class="p-error" *ngIf="submitted && !userView.userName">Se requiere nombre</small>
            </div>

            <div class="field p-text-bold">
                <label for="opt">Email</label>
                <input type="text" pInputText id="name" [(ngModel)]="userView.email" required autofocus />
                <!-- <small class="p-error" *ngIf="submitted && !userView.email">Se requiere email</small> -->
                <!-- <small class="p-error" *ngIf="submitted && !mailValid">Formato incorrecto Email</small> -->
                
            </div>

            <div class="field p-text-bold">
                <label for="opt">Celular</label>
                <!--input type="text" pInputText id="name" [(ngModel)]="userView.cellPhone" required autofocus /-->
                <!--p-inputMask mask="(99) 9999-9999" [(ngModel)]="userView.cellPhone" placeholder="(99) 9999-9999"></p-inputMask-->
                <p-inputNumber [(ngModel)]="userView.cellPhone" mode="decimal" inputId="withoutgrouping" [useGrouping]="false">
                </p-inputNumber>
            </div>

            <div class="field p-text-bold">
                <label for="opt">Idioma de Soporte</label>
                <!--input type="text" pInputText id="name" [(ngModel)]="userView.email" required autofocus /-->
                <p-dropdown  [virtualScroll]="true" [options]="listLanguage" [(ngModel)]="selectedLanguage" itemSize="30" optionLabel="descrip" [showClear]="true" placeholder="Seleccione Idioma"></p-dropdown>
            </div>
            <div class="field p-text-bold">
                <label for="opt">Tipo de usuario</label>
                <p-dropdown  [virtualScroll]="true" [options]="listUserTypes" [(ngModel)]="selectedUserType" itemSize="30" optionLabel="descrip" [showClear]="true" placeholder="Seleccione Tipo de usuario"></p-dropdown>
                <!--input type="text" pInputText id="name" [(ngModel)]="userView.cellPhone" required autofocus /-->
            </div>
            <div class="field p-text-bold">
                <label for="opt">Funcion de Soporte</label>
                <p-dropdown  [virtualScroll]="true" [options]="listFunctions" [(ngModel)]="selectedFunction" itemSize="30" optionLabel="descrip" [showClear]="true" placeholder="Seleccione Función"></p-dropdown>
                <!--input type="text" pInputText id="name" [(ngModel)]="userView.cellPhone" required autofocus /-->
            </div>
            
            <div class="field col-12 md:col-4 p-text-bold">
                <label for="comment">Comentarios</label>
                <textarea id="comment" pInputTextarea rows="2"  [(ngModel)]="userView.comments" cols="20"></textarea>
            </div>


        </ng-template>
    
        <ng-template pTemplate="footer">
            <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
            <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text"  (click)="createUserSupport()"></button>
        </ng-template>
    </p-dialog>

</p-fieldset>